// extracted by mini-css-extract-plugin
export default {"button":"ClearButton_button__vikak"};